document.addEventListener('DOMContentLoaded', () => {
  // Mobile toggle logic (no effect on desktop)
  const toggles = document.querySelectorAll('.custom-toggle');

  toggles.forEach((toggle) => {
    toggle.addEventListener('click', (e) => {
      if (window.innerWidth >= 990) return; // desktop skip
      e.preventDefault();

      const submenu = toggle.nextElementSibling;
      const isOpen = submenu && submenu.style.display === 'block';

      // Close all others
      document.querySelectorAll('.custom-submenu').forEach((menu) => (menu.style.display = 'none'));
      document.querySelectorAll('.custom-toggle').forEach((btn) => btn.setAttribute('aria-expanded', 'false'));

      if (!isOpen && submenu) {
        submenu.style.display = 'block';
        toggle.setAttribute('aria-expanded', 'true');
      }
    });
  });
});
